import { request } from "@/interface/helper";

const str = "settingStaffLog";

export const settingStaffLog = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/stafflog/list" }),
    add: data => request({ data, method: "post", url: "/stafflog/add" }),
    detail: data => request({ data, method: "post", url: "/stafflog/detail" }),
    edit: data => request({ data, method: "post", url: "/stafflog/modify" }),
    transfer: data => request({ data, method: "get", url: "/stafflog/transfer" }),
  }
};
